// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Add = React.forwardRef(function Add(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></SvgIcon>;
});
export default Add;
